<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="12" class="text-center text-sm-center mb-4 mb-sm-0">
        <img src="@/assets/images/logo/logo1.png" style="max-width:100%; max-height: 100px;" />
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12" style="text-align:center;">
        <div class="card-signup">
          <h2 class="page-title" style="text-align: center;padding-bottom: 20px;">Cadastrar</h2>
          <d-form id="signup-form" @submit="checkForm">
            <d-form-row>

              <!-- First Name -->
              <d-col md="12" class="form-group">
                <label for="feFirstName">Nome</label>
                <d-form-input type="text" name="feFirstName" id="feFirstName" v-model="feFirstName" placeholder="Nome" />
              </d-col>

            </d-form-row>

            <d-form-row>

              <!-- Email -->
              <d-col md="6" class="form-group">
                <label for="feEmail">Email</label>
                <d-form-input type="email" id="feEmail" v-model="feEmail" placeholder="Email" />
              </d-col>

              <!-- Password -->
              <d-col md="6" class="form-group">
                <label for="fePassword">Senha</label>
                <d-form-input type="password" id="fePassword" v-model="fePassword" placeholder="Senha" />
              </d-col>

            </d-form-row>

            <d-form-row>

              <!-- CPF -->
              <d-col md="4" class="form-group">
                <label for="cpf">CPF</label>
                <d-form-input type="text" id="cpf" v-model="cpf" v-mask="'###########'" placeholder="CPF" />
              </d-col>
              <d-col md="4" class="form-group">
                <label for="cell">Celular</label>
                <d-form-input type="text" id="cell" v-model="cell" v-mask="'###########'" placeholder="Telefone / celular" />
              </d-col>
              <d-col md="4" class="form-group">
                <label for="birth_date">Data de nascimento</label>
                <d-form-input type="text" id="birth_date" v-model="birth_date" v-mask="'##-##-####'" placeholder="Data de nascimento" />
              </d-col>

            </d-form-row>

            </d-form-row>
            <div class="message-error" v-if="errorCustom === 1">
              Preencha todos os campos acima!
            </div>
            <div class="message-error" v-if="errorCustom === 2">
              Já existe uma conta com esse email!
            </div>
            <div style="text-align:right;" v-if="!loading">
              <d-button type="submit" class="btn-accent">Criar conta</d-button>
            </div>
            <div style="text-align:right;" v-if="loading">
              <img src="/images/load2.gif" style="height: 20px;" />
            </div>

          </d-form>
        </div>
        <div style="text-align: center;padding-top: 10px;padding-bottom: 20px;">
          <a href="./login">Já tenho uma conta</a>
        </div>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import config from '../config'
import axios from 'axios'
import {mask} from 'vue-the-mask'
import {setCookie, getCookie} from '../utils'
export default {
  name: 'signup-form',
  directives: {mask},
  data() {
    return {
      errorCustom: 0,
      feFirstName: null,
      feEmail: null,
      fePassword: null,
      cpf: null,
      cell: null,
      planId: null,
      birth_date: null,
      holderName: null,
      cardnumber: null,
      validade: null,
      loading: false,
    };
  },
  methods: {
    checkForm(e) {
      e.preventDefault();
      if (!this.feFirstName || !this.feEmail || !this.fePassword || !this.cpf || !this.cell || !this.birth_date) {
        this.errorCustom = 1;
        return false;
      }
      this.errorCustom = 0;
      this.loading = true
      axios.post(config.serverUrl + '/v1/register',
      {
        name: this.feFirstName,
        email: this.feEmail,
        password: this.fePassword,
        cpf: this.cpf,
        phone: this.cell,
        plan_id: this.planId,
        birth_date: this.birth_date
      },
      {})
      .then((res) => {
        this.loading = false
        if (res.data.response) {
          setCookie('token-client', res.data.token, 2);
          setCookie('name-client', res.data.client.name, 2);
          setCookie('email-client', res.data.client.email, 2);
          setCookie('id-client', res.data.client.id, 2);
          document.location.href="./magazine"
        }
      })
      .catch((error) => {
        this.loading = false
        this.errorCustom = 2;
        console.log(error)
      })
      return false;
    },
  },
};
</script>

